import { useGlobalConfig }      from "context/GlobalContext";
import { useEffect }            from "react";
import { useNavigate }          from "react-router";

export const RootComponent = () => {

  const navigate = useNavigate()
  const { rc } = useGlobalConfig()

  useEffect(() => {

    // Auth guard will automatically redirect to login if no session is found
    rc.uiRouter.navigateToHome(navigate)
  })

  return (
    <></>
  )

}